module.exports = __webpack_public_path__ + "static/metaverse_bg-b8aaecd6b70ad95192cdbe417b6bcaf0.svg";